module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "wltp-electric.0392c975.svg";